<template>
  <div class="course-page">
    <SearchBar @on-sort="onSort" @on-input-click="onInputClick" :activeIndex="sortType - 1"></SearchBar>
    <main>
      <!-- <div @click="goVideo">video</div> -->

      <ScrollTree @on-select-tree="onSelectTree" :defaultSelectedId="classificationId" :data="treeList" />
      <ScrollList
        :data="courseData.records"
        :goodsInfo="goodsInfo"
        :total="courseData.total"
        :currentChildren="currentChildren"
        @on-select-tree-three="onSelectTreeThree"
        @show-pay="showPayHandle"
        @on-refresh="onRefresh"
      />
    </main>
  </div>
  <!-- 改为标准 v-model:show 绑定，移除 @change-show -->
  <PayCoursePopup v-model:show="showPay" :goodsInfo="goodsInfo" :categoryName="goods.categoryName" />
</template>

<script lang="ts" setup>
import { ref, watch } from 'vue'
import { postCourseHome, postCourseCatetory, postClassGoods } from '@/api/requests/CourseRequests'

import { useRouter, useRoute } from 'vue-router'
import { reqResHandle } from './utils'
import SearchBar from './components/SearchBar.vue'
import ScrollTree from './components/ScrollTree.vue'
import ScrollList from './components/ScrollList.vue'
import { TreeItem, ThildrenItem } from './types'
import { LmsCourseCategory, CourseHome, Goods, GoodsInfo } from '@/api/Models/CourseDetail'
import PayCoursePopup from './components/PayCoursePopup.vue'

import { useUsersStore } from '@/stores/users'
import { storeToRefs } from 'pinia'

const usersStore = useUsersStore()
const { collegeId } = storeToRefs(usersStore)
const route = useRoute()
const routeQuery = route.query as { sortType: string; category: string }
const sortType = ref(routeQuery.sortType ? Number(routeQuery.sortType) : 1)
const classificationId = ref(routeQuery.category || '')
const treeList = ref<LmsCourseCategory[]>([])
const courseData = ref<CourseHome>({
  records: [],
  current: 0,
  size: 0,
  total: 0,
  searchCount: false
})
const goods = ref<Goods>({} as Goods)
const goodsInfo = ref<GoodsInfo[]>([] as GoodsInfo[])
const showPay = ref(false)
// 增加：用于返回后抑制一次自动弹出的开关
const blockOnce = ref(false)
// const refreshing = ref(false)
const router = useRouter()
const currentChildren = ref<TreeItem | ThildrenItem>({
  id: '',
  name: '',
  parentId: '',
  categoryLevel: 0,
  courseNum: '',
  count: '',
  hasChildren: 0,
  children: []
})
const currentThreeChildren = ref<TreeItem | ThildrenItem>({
  id: '',
  name: '',
  parentId: '',
  categoryLevel: 0,
  children: [],
  courseNum: '',
  count: '',
  hasChildren: 0
})
const isThree = ref(false)
const showPayHandle = () => {
  // 返回后首次触发 show-pay 时，抑制一次自动弹出
  if (blockOnce.value) {
    blockOnce.value = false
    return
  }
  showPay.value = true
}
// 移除：不再需要 changeShow
// const changeShow = (value: boolean) => {
//   showPay.value = value
// }
const cacheId = ref('')
const onSort = (param: { sortType: number }) => {
  sortType.value = param.sortType
  getHomePage()
}
const onInputClick = () => {
  router.push({
    path: '/courseSearch',
    query: {
      sortType: sortType.value
    }
  })
}
// const goVideo = () => {
//   router.push({
//     path: '/rollVideo'
//   })
// }
const onSelectTree = (param: TreeItem | ThildrenItem) => {
  isThree.value = false
  currentChildren.value = param
  getHomePage()
  getClassGoods(param.id)
}
const onSelectTreeThree = (param: TreeItem | ThildrenItem) => {
  isThree.value = true
  currentThreeChildren.value = param
  getHomePage()
  getClassGoods(param.id)
}
const getHomePage = async () => {
  const params = {
    classificationId: isThree.value ? currentThreeChildren.value.id : currentChildren.value?.id || '',
    current: 1,
    size: 9999,
    sorts: [
      {
        sortType: sortType.value,
        desc: true
      }
    ]
  }
  const res = await postCourseHome(params, '0')
  if (res.code === 1) {
    courseData.value = res?.data
  } else {
    reqResHandle(res.code, res.msg as string, router)
  }
}

const getHomePageReset = async () => {
  const params = {
    classificationId: '',
    current: 1,
    size: 9999,
    sorts: [
      {
        sortType: 1,
        desc: true
      }
    ]
  }
  const res = await postCourseHome(params, '0')
  if (res.code === 1) {
    courseData.value = res?.data
  } else {
    reqResHandle(res.code, res.msg as string, router)
  }
}

const getClassGoods = async (id: string) => {
  cacheId.value = id
  const res = await postClassGoods({ classificationId: id }, '0')
  if (res.code === 1) {
    goods.value = res?.data
    goodsInfo.value = res?.data?.goodsInfo || []
  }
}

const getCourseCatetory = async () => {
  const res = await postCourseCatetory({ maxLevel: '3', loadingShow: '0' })
  if (res.code === 1) {
    treeList.value = res?.data?.lmsCourseCategories || []
  } else {
    reqResHandle(res.code, res.msg as string, router)
  }
}

const onRefresh = () => {
  getCourseCatetory()
  getHomePage()
  getClassGoods(cacheId.value)
}

const init = async () => {
  getCourseCatetory()
  // 如果没有初始值 则query为空 取全部内容
  if (!classificationId.value || classificationId.value === 'undefined') {
    getHomePage()
  }
  getClassGoods('')
}

watch(collegeId, () => {
  getCourseCatetory()
  getHomePageReset()
  getClassGoods('')
})

init()
</script>
<script lang="ts">
export default {
  name: 'course'
}
</script>
<style lang="less" scoped>
.course-page {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 50px);
  overflow: hidden;
  main {
    flex: 1;
    background: #fff;
    display: flex;
    flex-direction: row;
    margin-top: 44px;
    overflow: hidden;
    height: calc(100vh - 50px - 44px);
  }
}
</style>
